import { all } from 'redux-saga/effects';
import applicationsSagas from './applicationsSaga';
import authSagas from './authSaga';
import clientsSagas from './clientsSaga';
import usersSagas from './usersSaga';
import profileSagas from './profileSaga';
import businessLinesSaga from './businessLinesSaga';
import connectionsSaga from './connectionsSaga';

export default function* rootSaga() {
  yield all([
    applicationsSagas(),
    clientsSagas(),
    authSagas(),
    usersSagas(),
    profileSagas(),
    businessLinesSaga(),
    connectionsSaga(),
  ]);
}
